import ViewHzba from '@/pages/hzba/_id/index.vue';
import PdfPreview from '@/pages/hzba/_id/PdfPreview.vue';
export default [
    {
        path: '/ba/:baId/:subpage',
        name: 'hzbaViewSubpage',
        component: ViewHzba,
        meta: { requiresLoggedIn: true, authorizedUserGroups: ['gutachter', 'kunde']},
    },
    {
        path: '/ba/:baId/pdf-preview',
        name: 'hzbaPdfPreview',
        component: PdfPreview,
        meta: { requiresLoggedIn: true, authorizedUserGroups: ['gutachter', 'kunde']}
    },
    {
        path: '/ba/:baId',
        name: 'hzbaView',
        component: ViewHzba,
        meta: { requiresLoggedIn: true, authorizedUserGroups: ['gutachter', 'kunde']},
    },
];